export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">吃瓜APP</h2>
        <p className="text-sm text-foreground-500 mb-8">下载吃瓜APP，随时随地掌握网红明星最新爆料</p>
        <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-10">
          <div className="flex-1 w-full lg:w-auto">
            <h3 className="text-base font-semibold text-foreground-900 mb-3">吃瓜网站移动客户端</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              专为吃瓜爱好者打造的移动端应用。打开APP即可获得网红吃瓜吃料网每日爆料推送，第一时间接收国产51精品入口吃瓜爆料与网红最新爆料。
              支持离线阅读、夜间模式、个性化话题订阅，让你的吃瓜体验更畅快。
            </p>
            <div className="flex flex-wrap gap-3 mb-5">
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                实时推送
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                离线阅读
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                夜间模式
              </span>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                话题订阅
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <button className="flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                安卓版下载
              </button>
            </div>
          </div>
          <div className="flex-shrink-0 w-[240px] md:w-[280px]">
            <div className="relative aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200 shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20screen%20mockup%20for%20a%20news%20and%20entertainment%20gossip%20platform%2C%20clean%20UI%20design%20with%20card%20layout%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20Chinese%20language%20interface%2C%20minimal%20modern%20design%2C%20editorial%20style%2C%20professional%20app%20screenshot%20aesthetic&width=560&height=1000&seq=app-mockup-chigua&orientation=portrait"
                alt="吃瓜APP移动端界面展示"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}